var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BaseComponentPlus } from "react-vextensions";
import { PanelHeader } from "UI/Write/MapUI/Panel";
import { Column, Button, Row, RowLR, Pre, Spinner } from "react-vcomponents";
import { Vector2i } from "js-vextensions";
import { Observer } from "vwebapp-framework";
import { runInAction } from "mobx";
import { store } from "Store";
let DisplayPanel = class DisplayPanel extends BaseComponentPlus({}, {}) {
    render() {
        const { zoomIn } = this.props;
        const zoomLevel = store.main.write.map.zoomLevel;
        const scrollSpeed_keys = store.main.write.map.scrollSpeed_keys;
        const zoomSpeed_keys = store.main.write.map.zoomSpeed_keys;
        const splitAt = 150;
        return (React.createElement(Column, null,
            React.createElement(PanelHeader, { text: "Display" }),
            React.createElement(Column, null,
                React.createElement(Row, { ml: "auto" },
                    "Zoom: ",
                    zoomLevel.RoundTo_Str(.001),
                    React.createElement(Button, { ml: 5, text: "+", onClick: () => {
                            zoomIn(1.1, new Vector2i(.5, .5));
                        } }),
                    React.createElement(Button, { ml: 5, text: "-", onClick: () => {
                            zoomIn(1 / 1.1, new Vector2i(.5, .5));
                        } })),
                React.createElement(RowLR, { mt: 5, splitAt: splitAt },
                    React.createElement(Pre, null, "Scroll speed (keys): "),
                    React.createElement(Spinner, { step: 1, min: 0, max: 1000, style: { minWidth: 0 }, value: scrollSpeed_keys, onChange: val => {
                            runInAction("DisplayPanel.setScrollSpeed_keys", () => store.main.write.map.scrollSpeed_keys = val);
                        } })),
                React.createElement(RowLR, { mt: 5, splitAt: splitAt },
                    React.createElement(Pre, null, "Zoom speed (keys): "),
                    React.createElement(Spinner, { step: 1, min: 0, max: 100, style: { minWidth: 0 }, value: zoomSpeed_keys, onChange: val => {
                            runInAction("DisplayPanel.setZoomSpeed_keys", () => store.main.write.map.zoomSpeed_keys = val);
                        } })))));
    }
};
DisplayPanel = __decorate([
    Observer
], DisplayPanel);
export { DisplayPanel };
